import React, { useState, useEffect } from 'react'
import {Row,Col,Form,Button, Alert} from 'react-bootstrap'
import Card from '../../../components/Card'
import ToastNotification from '../../../components/Toast';
import { toast } from 'react-toastify';
import { API_USERS_PROFILE, API_SIGNUP_EMAIL_SEND_CODE, API_SIGNUP_EMAIL_VERIFY_CODE } from '../../../service/url';
import { postApiCall, getApiCall } from '../../../service/httpCall';
import { useNavigate, useParams } from 'react-router-dom';
import { USER_STATUS } from '../../../utilities/constant';
import { ROUTES } from '../../../utilities/constant';
import { useAuth, errorCheck } from '../auth/auth-utils';

const VALIDATION_MIN_PASSWORD_LENGTH = 6;

const CallCentreUserEdit = () => {

   const { id, uid } = useParams();
   const navigate = useNavigate();
   const { checkAuth } = useAuth();
   const [username, setUsername] = useState('');
   const [password, setPassword] = useState('');
   const [name, setName] = useState('');
   const [email, setEmail] = useState('');
   const [originalEmail, setOriginalEmail] = useState('');
   const [emailNeedsVerification, setEmailNeedsVerification] = useState(false);
   const [signupEmailOtp, setSignupEmailOtp] = useState('');
   const [signupEmailToken, setSignupEmailToken] = useState('');
   const [emailVerifiedForEdit, setEmailVerifiedForEdit] = useState(false);
   const [signupEmailBusy, setSignupEmailBusy] = useState(false);
   const [status, setStatus] = useState('');
   const [confirmPassword, setConfirmPassword] = useState('');
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [emailError, setEmailError] = useState("");
   const [usernameError, setUsernameError] = useState("");
   const [nameError, setNameError] = useState("");
   

   function getProfileApiUrl(){
      return API_USERS_PROFILE.replace(':id', uid);
   }

   useEffect( () => {

      const profileApiUrl = getProfileApiUrl();
      getApiCall(profileApiUrl, {})
      .then(onProfileGetSuccess).catch(onError);

   }, [id]);

   useEffect(() => {
      checkAuth(setToastProps, setShowToast)
    }, []);

   // useEffect( () => {

   //    if(toastProps){
   //       setShowToast(true);
   //    }

   // }, [toastProps]);

   function onProfileGetSuccess(resp){
         //Set user details
         setUsername(resp.username);
         setStatus(resp.status);
         setName(resp.name);
         setEmail(resp.email);
         setOriginalEmail(resp.email || '');
         setEmailNeedsVerification(resp.email_verified === false);
         setSignupEmailToken('');
         setSignupEmailOtp('');
         setEmailVerifiedForEdit(false);
   }

   const normalizeEmail = (value) => String(value || '').trim().toLowerCase();

   const emailRequiresVerification = () =>
      normalizeEmail(email) !== normalizeEmail(originalEmail) || emailNeedsVerification;

   const handleEmailChange = (e) => {
      const value = e.target.value;
      setEmail(value);
      validateEmail(value);
      setSignupEmailToken('');
      setSignupEmailOtp('');
      setEmailVerifiedForEdit(false);
   };

   const sendSignupEmailCode = async () => {
      if (!email.trim() || getEmailValidationError(email)) {
         toast.warning('Enter a valid email before sending a code.');
         return;
      }
      setSignupEmailBusy(true);
      try {
         await postApiCall(API_SIGNUP_EMAIL_SEND_CODE, {
            email: email.trim(),
            exclude_user_id: uid,
         });
         setSignupEmailToken('');
         setEmailVerifiedForEdit(false);
         toast.success('Verification code sent. Check the inbox for this email.');
      } catch (err) {
         toast.error(typeof err === 'string' ? err : 'Could not send verification code');
      } finally {
         setSignupEmailBusy(false);
      }
   };

   const verifySignupEmailOtp = async () => {
      if (!email.trim() || getEmailValidationError(email)) {
         toast.warning('Enter a valid email.');
         return;
      }
      if (!signupEmailOtp || signupEmailOtp.length !== 6) {
         toast.warning('Enter the 6-digit code from the email.');
         return;
      }
      setSignupEmailBusy(true);
      try {
         const data = await postApiCall(API_SIGNUP_EMAIL_VERIFY_CODE, {
            email: email.trim(),
            otp: signupEmailOtp.trim(),
         });
         if (data?.signupEmailToken) {
            setSignupEmailToken(data.signupEmailToken);
            setEmailVerifiedForEdit(true);
            toast.success('Email verified. You can save the user now.');
         } else {
            toast.error('Unexpected response from server');
         }
      } catch (err) {
         toast.error(typeof err === 'string' ? err : 'Verification failed');
         setEmailVerifiedForEdit(false);
         setSignupEmailToken('');
      } finally {
         setSignupEmailBusy(false);
      }
   };


   function validateForm(){

      let valid = true;

      if(!validateUsername(username)){
         valid = false;
         if(!username.trim()){
            toast.warning("Username required")
         } else {
            toast.warning(usernameError || "Invalid username format")
         }
      }
      else if(!validateName(name)){
         valid = false;
         if(!name.trim()){
            toast.warning("Name required")
         } else {
            toast.warning(nameError || "Invalid name format")
         }
      }
      else if(!status || isNaN(status)){
         valid = false;
         toast.warning("Status required")
      }
      else if(password.trim() && confirmPassword.trim()){
      
         if(password.trim().length < VALIDATION_MIN_PASSWORD_LENGTH || confirmPassword.trim().length < VALIDATION_MIN_PASSWORD_LENGTH){
            valid = false;
            toast.warning(`Password and confirm password must be of minimum ${VALIDATION_MIN_PASSWORD_LENGTH} characters`)
         }
         else if(password.trim() != confirmPassword.trim()){
            valid = false;
            toast.warning("Password and confirm password not matching")
         }
      
      }

      const emailValidationError = getEmailValidationError(email);
      if (emailValidationError) {
         setEmailError(emailValidationError);
         valid = false;
         toast.warning(emailValidationError);
      }

      if (emailRequiresVerification() && (!emailVerifiedForEdit || !signupEmailToken)) {
         valid = false;
         toast.warning('Verify this email first: use Send code, then enter the OTP and click Verify OTP.');
      }

      return valid;

   }

   async function submitForm(){

      setButtonDisable(true);

      if(!validateForm()){
         setButtonDisable(false);
         return;
      }

      const params = { username, name, email, status }
      if(password){
         params['password'] = password;
      }
      if (emailRequiresVerification() && signupEmailToken) {
         params.signup_email_token = signupEmailToken;
      }

      const profileApiUrl = getProfileApiUrl();
      postApiCall(profileApiUrl, params)
      .then(onUserUpdateSuccess)
      .catch(onError);

   }  

   function onUserUpdateSuccess(resp){ 
      toast.success("User updated successfully")
      setTimeout( () => {
         const callCentreUsersListPath = ROUTES.CALL_CENTRES.USERS.LIST.replace(':id', id);
         navigate(`/${callCentreUsersListPath}`);
      }, 1500);
   }

   
   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        setButtonDisable(false);
        toast.error(JSON.stringify(err))
      }
   }

   function RenderUserStatusOptions(){

      let arrStatusOptions = [<option value=''>Select status</option>]

      USER_STATUS.map( val => {
         arrStatusOptions.push(<option value={val.value}>{val.label}</option>);
      } )

      return arrStatusOptions;

   }

   const validateUsername = (value) => {
     const trimmedValue = value.trim();
     if (!trimmedValue) {
       setUsernameError("Username is required");
       return false;
     }
     if (trimmedValue.length < 3 || trimmedValue.length > 50) {
       setUsernameError("Username must be between 3 and 50 characters");
       return false;
     }
     if (!/^[a-zA-Z0-9_]+$/.test(trimmedValue)) {
       setUsernameError("Username can only contain letters, numbers, and underscores");
       return false;
     }
     setUsernameError("");
     return true;
   };

   const validateName = (value) => {
     const trimmedValue = value.trim();
     if (!trimmedValue) {
       setNameError("Name is required");
       return false;
     }
     if (trimmedValue.length < 2 || trimmedValue.length > 100) {
       setNameError("Name must be between 2 and 100 characters");
       return false;
     }
     if (!/^[a-zA-Z0-9_ ]+$/.test(trimmedValue)) {
       setNameError("Name can only contain letters, numbers, underscores, and spaces");
       return false;
     }
     setNameError("");
     return true;
   };

   const getEmailValidationError = (value) => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!value) {
        return "Email is required";
      }
      if (!emailPattern.test(value)) {
        return "Invalid email format";
      }
      return "";
    };

   const validateEmail = (value) => {
      setEmailError(getEmailValidationError(value));
    };


   return(
      <>
        <div>
            <Row>
               <Col xl="12" lg="12">
                  <Card>
                     <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">User Information</h4>
                        </div>
                     </Card.Header>
                     <Card.Body>
                        <div className="new-user-info">
                           {emailNeedsVerification && (
                              <Alert variant="warning" className="mb-3">
                                 This user has not verified their email yet. Send a verification code to the email below and click Verify OTP before saving.
                              </Alert>
                           )}
                           <form>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="username">User Name:</Form.Label>
                                    <Form.Control 
                                       type="text"  
                                       id="username" 
                                       placeholder="User Name" 
                                       maxLength={50}
                                       value={username} 
                                       onChange={e => {
                                          setUsername(e.target.value);
                                          validateUsername(e.target.value);
                                       }}
                                       onBlur={e => validateUsername(e.target.value)}
                                       className={usernameError ? "is-invalid" : ""}
                                    />
                                    {usernameError && <div className="invalid-feedback">{usernameError}</div>}
                                 </Form.Group>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="name">Full Name:</Form.Label>
                                    <Form.Control 
                                       type="text"  
                                       id="name" 
                                       maxLength={100} 
                                       value={name} 
                                       onChange={e => {
                                          setName(e.target.value);
                                          validateName(e.target.value);
                                       }}
                                       onBlur={e => validateName(e.target.value)}
                                       className={nameError ? "is-invalid" : ""}
                                       required 
                                    />
                                    {nameError && <div className="invalid-feedback">{nameError}</div>}
                                 </Form.Group>
                              </div>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="email">Email:</Form.Label>
                                    <Form.Control type="email"  id="email" maxLength={100} value={email}
                                    onChange={handleEmailChange}
                                    required
                                    />
                                    {emailError && <span className="text-danger">{emailError}</span>}
                                    {emailRequiresVerification() && (
                                       <div className="d-flex flex-wrap align-items-end gap-2 mt-2">
                                          <Form.Control
                                             type="text"
                                             inputMode="numeric"
                                             placeholder="6-digit code"
                                             maxLength={6}
                                             style={{ maxWidth: '140px' }}
                                             value={signupEmailOtp}
                                             onChange={(e) =>
                                                setSignupEmailOtp(e.target.value.replace(/\D/g, '').slice(0, 6))
                                             }
                                             disabled={signupEmailBusy}
                                          />
                                          <Button
                                             type="button"
                                             variant="outline-primary"
                                             size="sm"
                                             disabled={signupEmailBusy || !email.trim() || !!getEmailValidationError(email)}
                                             onClick={sendSignupEmailCode}
                                          >
                                             Send code
                                          </Button>
                                          <Button
                                             type="button"
                                             variant="outline-success"
                                             size="sm"
                                             disabled={signupEmailBusy || signupEmailOtp.length !== 6}
                                             onClick={verifySignupEmailOtp}
                                          >
                                             Verify OTP
                                          </Button>
                                          {emailVerifiedForEdit && (
                                             <span className="text-success small">Email verified</span>
                                          )}
                                       </div>
                                    )}
                                 </Form.Group>
                              </div>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="pass">Password:</Form.Label>
                                    <Form.Control type="password"  id="pass" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)}  />
                                 </Form.Group>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="rpass">Confirm Password:</Form.Label>
                                    <Form.Control type="password"  id="rpass" placeholder="Confirm Password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
                                 </Form.Group>
                              </div>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="status">Status:</Form.Label>
                                    <select value={status} onChange={e => setStatus(e.target.value)} className="form-select" id="status">
                                        <RenderUserStatusOptions/>
                                    </select>
                                 </Form.Group>
                              </div>
                              <hr/>
                              <Button onClick={async() => {submitForm()}} type="button" variant="btn btn-primary" disabled={buttonDisable}>
                                 Update &nbsp;
                                 {
                                    buttonDisable ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></>
                                 }
                              </Button>
                           </form>
                        </div>
                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </div>

         {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

      </>
  )

}

export default CallCentreUserEdit;